import { render } from "./AssignmentDetailsTable.vue?vue&type=template&id=a42f71d4&scoped=true"
import script from "./AssignmentDetailsTable.vue?vue&type=script&lang=js"
export * from "./AssignmentDetailsTable.vue?vue&type=script&lang=js"

import "./AssignmentDetailsTable.vue?vue&type=style&index=0&id=a42f71d4&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./AssignmentDetailsTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42f71d4"]])

export default __exports__